"use strict";

var $ = require('jquery');
var _ = require('underscore');
var Promise = require('bluebird');

function request(url, options) {
    options = options || {};
    options.headers = options.headers || {};
    var jqXHR = $.ajax( _.extend({
        url: url
    }, options));

    return Promise.resolve(jqXHR).then(function(res) {
        if (res.error) {
            throw new Error(res.error);
        }
        return res;
    }).catch(function(err){
        if (err && err.responseJSON && err.responseJSON.error) {
            throw new Error(err.responseJSON.error);
        }
        throw new Error(err.message || err);
    });
}

module.exports = request;



/** WEBPACK FOOTER **
 ** ./modules/utils/request.js
 **/